import axios from "axios";

export default function ProjectproductDeleteService(projectId, productId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/project/" + projectId + "/product/" + productId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
